import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getErrorMessage } from 'shared/utils/errorMessage';
import { getBukuTarifLogDetail } from 'features/admin-logs/api/get-buku-tarif-log-detail';
import {
  adminLogKeys,
  adminLogStaleTime,
} from 'features/admin-logs/api/queryKeys';

export const useBukuTarifLogDetail = () => {
  const { idClaim } = useParams();

  const { data, isLoading, isError } = useQuery(
    adminLogKeys.bukuTarifDetail(idClaim),
    () => getBukuTarifLogDetail(idClaim),
    {
      enabled: !!idClaim,
      staleTime: adminLogStaleTime.DETAIL,
      onError: (error) => {
        const message = getErrorMessage(error);
        toast.error(`Detail log buku tarif: ${message}`);
      },
    }
  );

  return { data, isLoading, isError };
};
